module.exports = __webpack_public_path__ + "media/images/home/cellu_m6-2c5f47ef62f549f74f195ba1922472f0.jpg";